import React, { useContext } from "react";

import classNames from "classnames";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import { Typography } from "clearsense-ui/components";
import ThemeContext from "contexts/ThemeContext";

import ContentBox from "./ContentBox";

const SummaryLineChart = ({ data, className, title = "" }) => {
  const { theme } = useContext(ThemeContext);
  const GRAPH_STROKE_COLORS = { dark: "#FFFFFF", light: "#333333" };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="border border-black dark:border-gray-200 border-solid bg-white dark:bg-gray-700 opacity-95 dark:opacity-100 p-2">
          {payload.map(
            ({ color, name, value: dataValue }, index) =>
              name !== "name" && (
                <p style={{ color }} key={index}>{`${name} : ${dataValue}`}</p>
              )
          )}
        </div>
      );
    }

    return null;
  };

  return (
    <ContentBox
      className={classNames(
        "justify-center items-center bg-white dark:bg-[#2f3941]",
        className
      )}
    >
      <div className="flex justify-center w-full">
        <Typography
          style="h4"
          type="semibold"
          className="dark:text-white flex justify-center w-full"
        >
          {title}
        </Typography>
      </div>
      <div className="h-[32vh] m-8 border-2 border-solid border-black dark:border-white pt-4 my-2 pr-8">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <XAxis
              tick={false}
              stroke={GRAPH_STROKE_COLORS?.[theme]}
              label={{
                value: "Time",
                position: "insideBottom",
                fill: GRAPH_STROKE_COLORS?.[theme],
              }}
            />
            <YAxis
              tick={false}
              stroke={GRAPH_STROKE_COLORS?.[theme]}
              label={{
                value: "Count of resources",
                angle: -90,
                position: "topleft",
                fill: GRAPH_STROKE_COLORS?.[theme],
              }}
            />
            <Tooltip content={CustomTooltip} />
            {Object.keys(data?.[0]).map((keyName, index) => (
              <Line
                key={index}
                type="monotone"
                dataKey={keyName}
                stroke={GRAPH_STROKE_COLORS?.[theme]}
                dot={false}
              />
            ))}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </ContentBox>
  );
};
export default SummaryLineChart;
